export default "__VITE_ASSET__DkXs$hXa__"